import { useTranslate } from "ra-core";
import { ArrayInput } from "@/components/admin/array-input";
import { SimpleFormIterator } from "@/components/admin/simple-form-iterator";
import { TextInput } from "@/components/admin/text-input";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

/** Settings section: the type lists of the « Staff » and « Partenaires » categories. */
export const SettingsPartners = () => {
  const translate = useTranslate();
  return (
    <Card id="partners">
      <CardContent className="space-y-4">
        <h2 className="text-xl font-semibold text-muted-foreground">
          {translate("resources.partners.name", { smart_count: 2 })}
        </h2>
        <h3 className="text-lg font-medium text-muted-foreground">
          {translate("crm.settings.partners.staff_types")}
        </h3>
        <ArrayInput source="staffTypes" label={false} helperText={false}>
          <SimpleFormIterator disableReordering disableClear>
            <TextInput source="label" label={false} />
          </SimpleFormIterator>
        </ArrayInput>

        <Separator />

        <h3 className="text-lg font-medium text-muted-foreground">
          {translate("crm.settings.partners.partner_types")}
        </h3>
        <ArrayInput source="partnerTypes" label={false} helperText={false}>
          <SimpleFormIterator disableReordering disableClear>
            <TextInput source="label" label={false} />
          </SimpleFormIterator>
        </ArrayInput>
      </CardContent>
    </Card>
  );
};
